export default "__VITE_ASSET__Pb$jWfr9__"